/* ============================================================
   Ace Chef Apparels — Service page system
   File: assets/ace-services.js
   One shared runtime for every "Ace Service — …" section.
   Data-attribute driven, idempotent, re-runs on section reload
   inside the theme editor. No dependencies.
   ============================================================ */
(function () {
  if (window.AceSV) { window.AceSV.init(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function once(el, flag) {
    if (!el || el.dataset['svi' + flag] === '1') return false;
    el.dataset['svi' + flag] = '1';
    return true;
  }
  function num(v, dflt) {
    var n = parseFloat(v);
    return isNaN(n) ? (dflt === undefined ? 0 : dflt) : n;
  }
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  function money(v, cur, dec) {
    var d = dec === undefined ? 2 : dec;
    var n = Math.round(v * Math.pow(10, d)) / Math.pow(10, d);
    var parts = n.toFixed(d).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (cur || '$') + parts.join('.');
  }

  /* ---------- 1. reveal on scroll ---------- */
  function reveal(root) {
    var els = $$('.sv-rev', root).filter(function (el) { return once(el, 'rev'); });
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-sv-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. count-up numbers ---------- */
  function counters(root) {
    var els = $$('[data-sv-count-to]', root).filter(function (el) { return once(el, 'cnt'); });
    if (!els.length) return;

    function run(el) {
      var to = num(el.getAttribute('data-sv-count-to'));
      var pre = el.getAttribute('data-sv-pre') || '';
      var post = el.getAttribute('data-sv-post') || '';
      var dec = parseInt(el.getAttribute('data-sv-dec') || '0', 10);
      if (reduce) { el.textContent = pre + to.toFixed(dec) + post; return; }
      var start = null, dur = 1200;
      function frame(ts) {
        if (start === null) start = ts;
        var p = clamp((ts - start) / dur, 0, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var v = to * eased;
        el.textContent = pre + v.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + post;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3. tab sets (pricing groups) ---------- */
  function tabs(root) {
    $$('[data-sv-tabset]', root).forEach(function (set) {
      if (!once(set, 'tab')) return;
      var btns = $$('[data-sv-tab]', set);
      var panels = $$('[data-sv-panel]', set);
      if (!btns.length) return;

      function show(key, focus) {
        btns.forEach(function (b) {
          var on = b.getAttribute('data-sv-tab') === key;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) b.focus();
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-sv-panel') !== key;
        });
        // let the estimator in the newly-shown panel refresh its layout
        panels.forEach(function (p) { if (!p.hidden) overflowFlags(p); });
      }

      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { show(b.getAttribute('data-sv-tab')); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
          if (!d) return;
          e.preventDefault();
          var nx = btns[(i + d + btns.length) % btns.length];
          show(nx.getAttribute('data-sv-tab'), true);
        });
      });

      var initial = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || btns[0];
      show(initial.getAttribute('data-sv-tab'));
    });
  }

  /* ---------- 4. pricing estimator ---------- */
  function estimators(root) {
    $$('[data-sv-est]', root).forEach(function (est) {
      if (!once(est, 'est')) return;

      var scope = est.closest('[data-sv-panel]') || est.closest('[data-sv-pricing]') || document;
      var range = $('[data-sv-range]', est);
      var input = $('[data-sv-qty]', est);
      var minus = $('[data-sv-minus]', est);
      var plus = $('[data-sv-plus]', est);
      var outUnit = $('[data-sv-out-unit]', est);
      var outSub = $('[data-sv-out-sub]', est);
      var outSetup = $('[data-sv-out-setup]', est);
      var outTotal = $('[data-sv-out-total]', est);
      var outEach = $('[data-sv-out-each]', est);
      var outTier = $('[data-sv-out-tier]', est);
      var save = $('[data-sv-save]', est);
      var saveVal = $('[data-sv-save-val]', est);
      var cta = $('[data-sv-est-cta]', est);
      var ctaBase = cta ? (cta.getAttribute('data-sv-est-cta') || cta.getAttribute('href') || '') : '';

      var cur = est.getAttribute('data-sv-cur') || '$';
      var setupBase = num(est.getAttribute('data-sv-setup'), 0);
      var minQ = num(est.getAttribute('data-sv-min'), 1);
      var maxQ = num(est.getAttribute('data-sv-max'), 500);
      var svcName = est.getAttribute('data-sv-service') || '';

      // rows live in the same panel; each carries qty range + unit price
      function rows() {
        return $$('[data-sv-row]', scope);
      }
      function opts() {
        return $$('[data-sv-opt][aria-pressed="true"]', est);
      }

      function pick(q) {
        var list = rows(), best = null;
        for (var i = 0; i < list.length; i++) {
          var r = list[i];
          var lo = num(r.getAttribute('data-sv-min'), 0);
          var hiAttr = r.getAttribute('data-sv-max');
          var hi = (hiAttr === null || hiAttr === '' || num(hiAttr, 0) <= 0) ? Infinity : num(hiAttr);
          if (q >= lo && q <= hi) { best = r; break; }
          if (!best && q < lo) best = r;         // below the first tier → use it
          if (q > hi) best = r;                   // above every tier → keep the last
        }
        return best || list[list.length - 1] || null;
      }

      function paint() {
        var q = clamp(Math.round(num(input && input.value, minQ)), minQ, maxQ);
        if (input && String(q) !== input.value) input.value = q;
        if (range) {
          range.value = q;
          var pct = maxQ > minQ ? ((q - minQ) / (maxQ - minQ)) * 100 : 0;
          range.style.setProperty('--sv-fill', pct.toFixed(2) + '%');
        }

        var row = pick(q);
        var unit = row ? num(row.getAttribute('data-sv-price'), 0) : 0;
        var label = row ? (row.getAttribute('data-sv-label') || '') : '';

        // option modifiers: additive per-unit, and additive to setup
        var addUnit = 0, addSetup = 0, optNames = [];
        opts().forEach(function (o) {
          addUnit += num(o.getAttribute('data-sv-delta'), 0);
          addSetup += num(o.getAttribute('data-sv-setup-delta'), 0);
          var n = o.getAttribute('data-sv-name');
          if (n) optNames.push(n);
        });

        var each = Math.max(0, unit + addUnit);
        var sub = each * q;
        var setup = setupBase + addSetup;
        var total = sub + setup;

        // highlight the live tier
        rows().forEach(function (r) { r.classList.toggle('is-active', r === row); });

        if (outUnit) outUnit.textContent = money(each, cur);
        if (outEach) outEach.textContent = money(each, cur);
        if (outSub) outSub.textContent = money(sub, cur);
        if (outSetup) outSetup.textContent = setup > 0 ? money(setup, cur) : 'Included';
        if (outTotal) outTotal.textContent = money(total, cur);
        if (outTier) outTier.textContent = label;

        // savings vs the first (most expensive) tier
        var list = rows();
        if (save && list.length) {
          var top = num(list[0].getAttribute('data-sv-price'), 0) + addUnit;
          var diff = (top - each) * q;
          if (diff > 0.5) {
            save.hidden = false;
            if (saveVal) saveVal.textContent = money(diff, cur, 0);
          } else {
            save.hidden = true;
          }
        }

        // carry the whole estimate through to the quote page
        if (cta && ctaBase) {
          if (ctaBase.indexOf('mailto:') === 0) {
            cta.setAttribute('href', ctaBase);
          } else {
            var parts = ['qty=' + q];
            if (svcName) parts.push('service=' + encodeURIComponent(svcName));
            if (optNames.length) parts.push('options=' + encodeURIComponent(optNames.join(', ')));
            parts.push('unit=' + each.toFixed(2));
            parts.push('setup=' + setup.toFixed(2));
            parts.push('total=' + total.toFixed(2));
            if (label) parts.push('tier=' + encodeURIComponent(label));
            var join = ctaBase.indexOf('?') > -1 ? '&' : '?';
            cta.setAttribute('href', ctaBase + join + parts.join('&'));
          }
        }
      }

      if (range) {
        range.min = minQ; range.max = maxQ;
        range.addEventListener('input', function () { if (input) input.value = range.value; paint(); });
      }
      if (input) {
        input.min = minQ; input.max = maxQ;
        input.addEventListener('input', paint);
        input.addEventListener('change', paint);
        input.addEventListener('blur', paint);
      }
      if (minus) minus.addEventListener('click', function () {
        var st = num(minus.getAttribute('data-sv-stepsize'), 1);
        if (input) input.value = num(input.value, minQ) - st; paint();
      });
      if (plus) plus.addEventListener('click', function () {
        var st = num(plus.getAttribute('data-sv-stepsize'), 1);
        if (input) input.value = num(input.value, minQ) + st; paint();
      });

      // option chips — radio behaviour inside a group, toggle when standalone
      $$('[data-sv-opt]', est).forEach(function (o) {
        o.addEventListener('click', function () {
          var grp = o.getAttribute('data-sv-optgroup');
          if (grp) {
            $$('[data-sv-optgroup="' + grp + '"]', est).forEach(function (x) {
              x.setAttribute('aria-pressed', x === o ? 'true' : 'false');
            });
          } else {
            o.setAttribute('aria-pressed', o.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          }
          paint();
        });
      });

      // clicking a tier row/card jumps the quantity to that tier
      rows().forEach(function (r) {
        if (!once(r, 'row')) return;
        var jump = r.getAttribute('data-sv-jump');
        if (jump === 'off') return;
        r.classList.add('is-clickable');
        var go = function () {
          var lo = num(r.getAttribute('data-sv-min'), minQ);
          if (input) input.value = clamp(lo, minQ, maxQ);
          paint();
          if (est.getBoundingClientRect().top < 0) {
            est.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          }
        };
        r.addEventListener('click', go);
        r.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
        });
      });

      paint();
    });
  }

  /* ---------- 5. chip / tag filtering ---------- */
  function filters(root) {
    $$('[data-sv-filterset]', root).forEach(function (set) {
      if (!once(set, 'flt')) return;
      var btns = $$('[data-sv-filter]', set);
      var items = $$('[data-sv-item]', set);
      var empty = $('[data-sv-empty]', set);
      if (!btns.length || !items.length) return;

      // live counts
      btns.forEach(function (b) {
        var key = b.getAttribute('data-sv-filter');
        var c = $('[data-sv-fcount]', b);
        if (!c) return;
        c.textContent = key === 'all' ? items.length : items.filter(function (it) {
          return (it.getAttribute('data-sv-item') || '').split('|').indexOf(key) > -1;
        }).length;
      });

      function apply(key) {
        var shown = 0;
        items.forEach(function (it) {
          var keys = (it.getAttribute('data-sv-item') || '').split('|');
          var on = key === 'all' || keys.indexOf(key) > -1;
          it.hidden = !on;
          if (on) shown++;
        });
        btns.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-sv-filter') === key ? 'true' : 'false');
        });
        if (empty) empty.hidden = shown > 0;
      }

      btns.forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-sv-filter')); });
      });
      var init = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
      apply(init.getAttribute('data-sv-filter'));
    });
  }

  /* ---------- 6. process stepper ---------- */
  function steppers(root) {
    $$('[data-sv-stepper]', root).forEach(function (st) {
      if (!once(st, 'stp')) return;
      var btns = $$('[data-sv-step]', st);
      var panels = $$('[data-sv-steppanel]', st);
      var fill = $('[data-sv-pfill]', st);
      var nav = $('[data-sv-stepnav]', st);
      if (!btns.length) return;

      function show(key) {
        var idx = 0;
        btns.forEach(function (b, i) {
          var on = b.getAttribute('data-sv-step') === key;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.setAttribute('tabindex', on ? '0' : '-1');
          if (on) idx = i;
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-sv-steppanel') !== key; });
        var pct = ((idx + 1) / btns.length) * 100;
        if (fill) fill.style.setProperty('--sv-pfill', pct.toFixed(2) + '%');
        if (nav && btns[idx]) {
          var b = btns[idx];
          if (nav.scrollWidth > nav.clientWidth) {
            nav.scrollTo({ left: b.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
          }
        }
      }

      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { show(b.getAttribute('data-sv-step')); });
        b.addEventListener('keydown', function (e) {
          var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1
                : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var nx = btns[(i + d + btns.length) % btns.length];
          show(nx.getAttribute('data-sv-step'));
          nx.focus();
        });
      });

      // prev / next inside the panels
      $$('[data-sv-stepmove]', st).forEach(function (m) {
        m.addEventListener('click', function () {
          var cur = btns.map(function (b) { return b.getAttribute('aria-selected') === 'true'; }).indexOf(true);
          if (cur < 0) cur = 0;
          var d = m.getAttribute('data-sv-stepmove') === 'next' ? 1 : -1;
          var nx = btns[clamp(cur + d, 0, btns.length - 1)];
          show(nx.getAttribute('data-sv-step'));
        });
      });

      var init = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || btns[0];
      show(init.getAttribute('data-sv-step'));
    });
  }

  /* ---------- 7. FAQ accordion + search ---------- */
  function faqs(root) {
    $$('[data-sv-faqset]', root).forEach(function (set) {
      if (!once(set, 'faq')) return;
      var items = $$('[data-sv-faq]', set);
      var search = $('[data-sv-faqsearch]', set);
      var single = set.getAttribute('data-sv-faqsingle') === 'true';
      var empty = $('[data-sv-empty]', set);

      items.forEach(function (it) {
        var q = $('[data-sv-faqq]', it);
        var a = $('[data-sv-faqa]', it);
        if (!q || !a) return;

        function close() {
          q.setAttribute('aria-expanded', 'false');
          a.style.height = a.scrollHeight + 'px';
          requestAnimationFrame(function () { a.style.height = '0px'; });
        }
        function open() {
          q.setAttribute('aria-expanded', 'true');
          a.style.height = a.scrollHeight + 'px';
          window.setTimeout(function () {
            if (q.getAttribute('aria-expanded') === 'true') a.style.height = 'auto';
          }, 340);
        }

        // start from the markup's own state
        if (q.getAttribute('aria-expanded') === 'true') { a.style.height = 'auto'; }
        else { a.style.height = '0px'; }

        q.addEventListener('click', function () {
          var isOpen = q.getAttribute('aria-expanded') === 'true';
          if (single && !isOpen) {
            items.forEach(function (other) {
              if (other === it) return;
              var oq = $('[data-sv-faqq]', other), oa = $('[data-sv-faqa]', other);
              if (oq && oa && oq.getAttribute('aria-expanded') === 'true') {
                oq.setAttribute('aria-expanded', 'false');
                oa.style.height = oa.scrollHeight + 'px';
                requestAnimationFrame(function () { oa.style.height = '0px'; });
              }
            });
          }
          isOpen ? close() : open();
        });
      });

      if (search) {
        search.addEventListener('input', function () {
          var t = search.value.trim().toLowerCase();
          var shown = 0;
          items.forEach(function (it) {
            var hay = (it.textContent || '').toLowerCase();
            var on = !t || hay.indexOf(t) > -1;
            it.hidden = !on;
            if (on) shown++;
          });
          if (empty) empty.hidden = shown > 0;
        });
      }
    });
  }

  /* ---------- 8. horizontal-overflow flags ---------- */
  function overflowFlags(root) {
    $$('[data-sv-overflow]', root).forEach(function (w) {
      var sc = $('[data-sv-overflow-scroll]', w) || w;
      var check = function () {
        w.classList.toggle('is-overflowing', sc.scrollWidth > sc.clientWidth + 2);
      };
      check();
      if (once(w, 'ovf')) window.addEventListener('resize', check);
    });
  }

  /* ---------- 9. scroll cue ---------- */
  function cues(root) {
    $$('[data-sv-cue]', root).forEach(function (b) {
      if (!once(b, 'cue')) return;
      b.addEventListener('click', function () {
        var host = b.closest('.sv') || b.parentElement;
        var next = host && host.nextElementSibling;
        if (next && next.scrollIntoView) {
          next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        } else {
          window.scrollBy({ top: window.innerHeight * 0.85, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });
  }


  /* ---------- 10. quote-form prefill ----------------------------------
     Carries the estimate from the pricing page into the quote form.

     The GHL form is a cross-origin iframe, so we cannot type into it.
     The supported route is to append the values to the iframe's own URL
     as query parameters keyed by each field's GHL query key. We also
     forward gclid/utm_* here, because the forwarder in theme.liquid
     only matches leadconnectorhq / msgsndr and never url.floqo.ai.
  -------------------------------------------------------------------- */
  var SV_KEYS = ['qty', 'service', 'options', 'tier', 'unit', 'setup', 'total'];
  // `band` is derived from qty, not read from the URL, so it is listed separately
  var SV_SHOW = ['band', 'options', 'tier', 'unit', 'setup', 'total'];
  var SV_MONEY_KEYS = { unit: 1, setup: 1, total: 1 };
  var SS = 'aceSV.quote';

  function readParams() {
    var out = {}, q;
    try { q = new URLSearchParams(location.search); } catch (e) { return out; }
    var got = false;
    SV_KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v !== null && v !== '') { out[k] = v; got = true; }
    });
    if (got) {
      try { sessionStorage.setItem(SS, JSON.stringify(out)); } catch (e) {}
      return out;
    }
    // no params this time — fall back to what we stored on arrival, so a
    // GHL iframe reload or an in-page navigation does not lose the estimate
    try {
      var saved = JSON.parse(sessionStorage.getItem(SS) || '{}');
      return saved && typeof saved === 'object' ? saved : {};
    } catch (e) { return {}; }
  }

  function parseMap(raw) {
    var map = [];
    String(raw || '').split(/[\r\n]+/).forEach(function (line) {
      var i = line.indexOf('=');
      if (i < 0) return;
      var from = line.slice(0, i).trim();
      var to = line.slice(i + 1).trim();
      if (from && to) map.push([from, to]);
    });
    return map;
  }

  /* A GHL "Approximate quantity" dropdown holds bands ("10–50"), not exact
     numbers, and a query param can only select an option it matches exactly.
     So derive a band label from the quantity and expose it as `band`. */
  function bandFor(qty, raw) {
    var n = parseFloat(qty);
    if (isNaN(n)) return '';
    var lines = String(raw || '').split(/[\r\n]+/);
    for (var i = 0; i < lines.length; i++) {
      var eq = lines[i].indexOf('=');
      if (eq < 0) continue;
      var range = lines[i].slice(0, eq).trim();
      var label = lines[i].slice(eq + 1).trim();
      if (!range || !label) continue;
      var m = range.split('-');
      var lo = m[0] === undefined || m[0].trim() === '' ? -Infinity : parseFloat(m[0]);
      var hi = m.length < 2 || m[1].trim() === '' ? Infinity : parseFloat(m[1]);
      if (isNaN(lo)) lo = -Infinity;
      if (isNaN(hi)) hi = Infinity;
      if (n >= lo && n <= hi) return label;
    }
    return '';
  }

  /* The whole estimate as one string, so it can go into a single (ideally
     hidden) field instead of needing one field per number. */
  function summaryFor(vals, cur) {
    var bits = [];
    if (vals.service) bits.push(vals.service);
    if (vals.qty) bits.push(vals.qty + ' garments');
    if (vals.tier) bits.push('tier ' + vals.tier);
    if (vals.options) bits.push(vals.options);
    if (vals.unit) bits.push(cur + vals.unit + '/garment');
    if (vals.setup && parseFloat(vals.setup) > 0) bits.push('setup ' + cur + vals.setup);
    if (vals.total) bits.push('est. total ' + cur + vals.total);
    return bits.join(' \u00b7 ');
  }

  function parseList(raw) {
    return String(raw || '').split(/[\s,\r\n]+/).map(function (x) { return x.trim(); })
      .filter(Boolean);
  }

  function ghlIframes(root) {
    return $$('iframe', root || document).filter(function (f) {
      var src = f.getAttribute('src') || '';
      return /url\.floqo\.ai|leadconnectorhq|msgsndr|\/widget\/form\//.test(src);
    });
  }

  function prefill(root) {
    $$('[data-sv-prefill]', root).forEach(function (host) {
      if (!once(host, 'pf')) return;

      var vals = readParams();
      var band = bandFor(vals.qty, host.getAttribute('data-sv-bands'));
      if (band) vals.band = band;
      var curEarly = host.getAttribute('data-sv-cur') || '$';
      var sumStr = summaryFor(vals, curEarly);
      if (sumStr) vals.summary = sumStr;
      var map = parseMap(host.getAttribute('data-sv-map'));
      var forward = parseList(host.getAttribute('data-sv-forward'));
      var debug = host.getAttribute('data-sv-debug') === 'true';
      var cur = host.getAttribute('data-sv-cur') || '$';
      var hasVals = Object.keys(vals).length > 0;

      /* ---- a. rewrite the GHL iframe URLs ----
         Not a one-shot: GHL's form_embed.js can re-render or reset the
         iframe's src after we run, which would silently drop everything.
         So we re-apply whenever the expected keys go missing, capped at a
         few attempts per iframe so a script fighting us cannot loop. */
      var MAX_STAMPS = 4;

      function wanted() {
        var out = {};
        map.forEach(function (pair) {
          var v = vals[pair[0]];
          if (v !== undefined && v !== '') out[pair[1]] = String(v);
        });
        forward.forEach(function (k) {
          var v = null;
          try { v = new URLSearchParams(location.search).get(k); } catch (e) {}
          if (!v) { try { v = localStorage.getItem('acecl_' + k); } catch (e) {} }
          if (v) out[k] = String(v);
        });
        return out;
      }

      function stamp(frame) {
        if (!frame) return;
        var tries = parseInt(frame.dataset.svPfN || '0', 10);
        if (tries >= MAX_STAMPS) return;

        var url;
        try { url = new URL(frame.src, location.href); } catch (e) { return; }

        var want = wanted();
        var keys = Object.keys(want);
        if (!keys.length) return;

        // already carrying everything? leave it alone
        var missing = keys.filter(function (k) { return url.searchParams.get(k) !== want[k]; });
        if (!missing.length) return;

        keys.forEach(function (k) { url.searchParams.set(k, want[k]); });
        frame.dataset.svPfN = String(tries + 1);
        var next = url.toString();
        if (next !== frame.src) frame.src = next;
        if (debug) {
          try {
            console.log('[AceSV prefill] values:', vals);
            console.log('[AceSV prefill] form URL:', next);
            var sent = [];
            url.searchParams.forEach(function (val, key) { sent.push(key + '=' + val); });
            console.log('[AceSV prefill] params sent:', sent.join('  |  '));
          } catch (e) {}
        }
      }

      ghlIframes().forEach(stamp);

      // form_embed.js can inject the iframe, or rewrite the src of the one
      // already there — watch for both
      if (window.MutationObserver) {
        var mo = new MutationObserver(function () { ghlIframes().forEach(stamp); });
        mo.observe(document.body, {
          childList: true, subtree: true,
          attributes: true, attributeFilter: ['src'],
        });
        setTimeout(function () { mo.disconnect(); }, 15000);
      }

      /* ---- b. prefill the native Shopify form fallback ---- */
      if (host.getAttribute('data-sv-native') === 'true' && hasVals) {
        var setField = function (name, v) {
          if (v === undefined || v === '') return;
          var el = document.querySelector('[name="contact[' + name + ']"]');
          if (!el || el.value) return;
          if (el.tagName === 'SELECT') {
            var want = String(v).toLowerCase();
            var hit = Array.prototype.slice.call(el.options).filter(function (o) {
              var t = (o.textContent || '').trim().toLowerCase();
              return t === want || (t && want.indexOf(t) === 0) || (t && t.indexOf(want) === 0);
            })[0];
            if (hit) el.value = hit.value || hit.textContent.trim();
          } else {
            el.value = v;
          }
        };
        setField('Quantity', vals.qty);
        setField('Service', vals.service);
        setField('Garments', vals.options);

        if (host.getAttribute('data-sv-body') === 'true') {
          var body = document.querySelector('[name="contact[body]"]');
          if (body && !body.value) {
            var lines = [];
            if (vals.service) lines.push('Service: ' + vals.service);
            if (vals.qty) lines.push('Quantity: ' + vals.qty);
            if (vals.tier) lines.push('Quantity band: ' + vals.tier);
            if (vals.options) lines.push('Options: ' + vals.options);
            if (vals.unit) lines.push('Price per garment (est.): ' + cur + vals.unit);
            if (vals.setup) lines.push('One-off setup (est.): ' + cur + vals.setup);
            if (vals.total) lines.push('Estimated total: ' + cur + vals.total);
            if (lines.length) {
              body.value = 'From the pricing table:\n' + lines.join('\n') + '\n\n';
            }
          }
        }
      }

      /* ---- c. the summary card ---- */
      var card = $('[data-sv-summary-card]', host);
      if (card && host.getAttribute('data-sv-summary') === 'true' && hasVals) {
        var labels = {};
        try { labels = JSON.parse(($('[data-sv-labels]', host) || {}).textContent || '{}'); }
        catch (e) {}

        var title = $('[data-sv-summary-title]', host);
        if (title) {
          var bits = [];
          if (vals.qty) bits.push(vals.qty);
          if (vals.service) bits.push('× ' + vals.service);
          title.textContent = bits.length ? bits.join(' ') : (labels.total || 'Your estimate');
        }

        var list = $('[data-sv-summary-list]', host);
        if (list) {
          list.textContent = '';
          SV_SHOW.forEach(function (k) {
            var v = vals[k];
            if (v === undefined || v === '') return;
            var dt = document.createElement('dt');
            dt.textContent = labels[k] || k;
            var dd = document.createElement('dd');
            dd.textContent = SV_MONEY_KEYS[k] ? cur + v : v;
            if (k === 'total') dd.className = 'is-total';
            list.appendChild(dt);
            list.appendChild(dd);
          });
        }
        card.hidden = false;
      }

      var clear = $('[data-sv-summary-clear]', host);
      if (clear) {
        clear.addEventListener('click', function () {
          try { sessionStorage.removeItem(SS); } catch (e) {}
          if (card) card.hidden = true;
          try {
            var u = new URL(location.href);
            SV_KEYS.forEach(function (k) { u.searchParams.delete(k); });
            history.replaceState(null, '', u.toString());
          } catch (e) {}
        });
      }
    });
  }


  /* ---------- 11. hero header clearance ------------------------------
     theme.liquid positions the site header ON TOP of the hero, and its
     height changes with the announcement bar, the inline search row and
     the breakpoint. Any hard-coded gap is wrong somewhere, so measure the
     real overlap on load and write it into --sv-hero-clear.
  ------------------------------------------------------------------- */
  var HDR_SEL = 'header.site, .shopify-section-group-header-group, ' +
                '#shopify-section-header, header[role="banner"], body > header';

  function heroClear(root) {
    $$('[data-sv-hero]', root).forEach(function (hero) {
      if (hero.getAttribute('data-sv-autoclear') !== 'true') return;
      var gap = num(hero.getAttribute('data-sv-clear-gap'), 28);

      function apply() {
        var hdr = document.querySelector(HDR_SEL);
        if (!hdr || !hdr.offsetHeight) return;
        var need;
        if (window.scrollY > 4) {
          // header may be in its fixed/stuck state — its height is the best guide
          need = hdr.offsetHeight;
        } else {
          // measure the actual overlap over the top of the hero
          var hr = hdr.getBoundingClientRect();
          var er = hero.getBoundingClientRect();
          need = Math.max(0, hr.bottom - er.top);
        }
        var val = clamp(Math.round(need + gap), 0, 360);
        hero.style.setProperty('--sv-hero-clear', val + 'px');
        hero.style.setProperty('--sv-hero-clear-m', val + 'px');
      }

      apply();
      if (!once(hero, 'clr')) return;
      window.addEventListener('resize', apply);
      window.addEventListener('load', apply);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(apply).catch(function () {});
      }
      // the header's own scripts can resize it a beat after load
      setTimeout(apply, 350);
      setTimeout(apply, 1200);
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    var r = root || document;
    try { reveal(r); } catch (e) {}
    try { counters(r); } catch (e) {}
    try { tabs(r); } catch (e) {}
    try { estimators(r); } catch (e) {}
    try { filters(r); } catch (e) {}
    try { steppers(r); } catch (e) {}
    try { faqs(r); } catch (e) {}
    try { overflowFlags(r); } catch (e) {}
    try { cues(r); } catch (e) {}
    try { prefill(r); } catch (e) {}
    try { heroClear(r); } catch (e) {}
  }

  window.AceSV = { init: init, money: money };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // theme editor: sections are re-rendered without a page load
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var q = t && t.querySelector && t.querySelector('[data-sv-faqq]');
    if (q && q.getAttribute('aria-expanded') === 'false') q.click();
    var step = t && t.getAttribute && t.getAttribute('data-sv-steppanel-for');
    if (step) {
      var btn = document.querySelector('[data-sv-step="' + step + '"]');
      if (btn) btn.click();
    }
  });
})();
